import { axiosInstance } from './axios-instance';
import * as api from './api-routes';

// Serializes arrays as key=val&key=val (not key[]=val) for Spring @RequestParam List<String>
const repeatParamsSerializer = (params) => {
    const parts = [];
    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null) return;
        if (Array.isArray(value)) {
            value.forEach(v => parts.push(`${key}=${encodeURIComponent(v)}`));
        } else {
            parts.push(`${key}=${encodeURIComponent(value)}`);
        }
    });
    return parts.join('&');
};

export const getPurchaseOrders = ({ statuses, branch, dateFrom, dateTo, poId } = {}) =>
    axiosInstance.get(api.GET_PURCHASE_ORDERS, {
        params: { statuses, branch, dateFrom, dateTo, poId },
        paramsSerializer: repeatParamsSerializer
    }).then(res => res.data);

export const getPurchaseOrder = ({ poId }) =>
    axiosInstance.get(api.GET_PURCHASE_ORDER, {
        params: { poId }
    }).then(res => res.data);

export const getPoImages = ({ poId }) =>
    axiosInstance.get(api.GET_PO_IMAGES, {
        params: { poId }
    }).then(res => res.data);

export const uploadPoImages = (poId, files, uploaderName = '') => {
    const formData = new FormData();
    formData.append('poId', poId);
    files.forEach(file => formData.append('files', file));

    return axiosInstance.post(api.UPLOAD_PO_IMAGES, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'X-Uploader-Name': uploaderName
        }
    }).then(res => res.data);
};